import { render } from "./RuiDynamicInput.vue?vue&type=template&id=1c52698f&scoped=true"
import script from "./RuiDynamicInput.vue?vue&type=script&lang=ts"
export * from "./RuiDynamicInput.vue?vue&type=script&lang=ts"

import "./RuiDynamicInput.vue?vue&type=style&index=0&id=1c52698f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1c52698f"

export default script